import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=f666cb12&scoped=true&"
import script from "./ImportFile.vue?vue&type=script&lang=ts&"
export * from "./ImportFile.vue?vue&type=script&lang=ts&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=f666cb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f666cb12",
  null
  
)

export default component.exports